import { useQueryClient } from '@tanstack/react-query';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';

export const useMarkResolved = ({
  companyId,
  onSuccess,
}: {
  companyId: string;
  onSuccess?: () => void;
}) => {
  const queryClient = useQueryClient();
  const { mutate: markAsResolved } = useAppMutation(
    [QueryKey.MARK_NOTIFICATION_AS_RESOLVED, companyId],
    {
      mutationFn: (notificationId: string) =>
        ApiService.post({
          endpoint: BackendRoute.COMPANIES,
          routePath: [companyId, 'notifications', notificationId, 'mark-resolved'],
        }),
      onSuccess: () => {
        onSuccess?.();
        queryClient.invalidateQueries({ queryKey: [QueryKey.GET_NOTIFICATIONS] });
        queryClient.invalidateQueries({ queryKey: [QueryKey.GET_UNREAD_NOTIFICATION_COUNT] });
      },
    },
  );

  return {
    markAsResolved,
  };
};
